import { LunchLitelyService, LunchLitelyServiceModule } from '@b2b/common/services/lunchLitely/lunchLitely.service';
import { TODO } from '@b2b/types/core';
import angular, { IScope } from 'angular';

interface TileOption {
  id: string;
  icon: string;
  name: string;
  subTitle: string;
  x: number;
  y: number;
  type: string;
  showCapacity: boolean;
  price?: number;
  presell?: { date: string };
  color: { r: number; g: number; b: number; a: number };
  config: { x: number; y: number; type: string };
}

interface TileMap {
  generalAdmission: TileOption[];
  standard: TileOption[];
  addon: TileOption[];
  navigation: TileOption[];
  membership: TileOption[];
  donation: TileOption[];
  comboEvent?: TileOption[];
}

PosCreatePagesFormsTileController.$inject = ['$scope', 'PosConfigService', 'LunchLitelyService'];

function PosCreatePagesFormsTileController(
  $scope: IScope & { posCreatePagesFormsTile: TODO },
  PosConfigService: TODO,
  lunchLitelyService: LunchLitelyService,
) {
  const ctrl = {
    model: {} as TODO,

    allowNavigationTiles: true,
    enablePosComboEvents: false,
    selected: {
      type: false as string | false,
    },

    tiles: {
      generalAdmission: [
        {
          id: '54a1a3c47d84d983f315a0d8',
          icon: 'none',
          name: 'General Admission',
          subTitle: 'Ticket type',
          x: 0,
          y: 0,
          type: 'rollup',
          showCapacity: true,
          price: 0.0,
          presell: { date: '2015-06-25' },
          color: { r: 255, g: 70, b: 70, a: 1 },
          config: { x: 1, y: 1, type: 'generalAdmission' },
        },
      ],
      standard: [
        {
          id: '54a1a3c47d84d983f315a0d8',
          icon: 'none',
          name: 'Event Name',
          subTitle: 'Ticket type',
          x: 0,
          y: 0,
          type: 'rollup',
          showCapacity: true,
          presell: { date: '2015-06-25' },
          color: { r: 227, g: 174, b: 81, a: 1 },
          config: { x: 1, y: 1, type: 'standard' },
        },
      ],
      addon: [
        {
          id: '54a1a3c47d84d983f315a0d8',
          icon: 'none',
          name: 'Addon',
          subTitle: '',
          x: 0,
          y: 0,
          type: 'rollup',
          price: 0.0,
          showCapacity: false,
          color: { r: 113, g: 81, b: 227, a: 1 },
          config: { x: 0, y: 0, type: 'addon' },
        },
      ],
      navigation: [
        {
          id: '54a1a3c47d84d983f315a0d8',
          icon: 'none',
          name: 'Navigation',
          subTitle: '',
          x: 0,
          y: 0,
          type: 'rollup',
          showCapacity: false,
          color: { r: 81, g: 227, b: 174, a: 1 },
          config: { x: 0, y: 0, type: 'navigation' },
        },
      ],
      membership: [
        {
          id: '54a1a3c47d84d983f315a0d8',
          icon: 'none',
          name: 'Membership',
          subTitle: '',
          x: 0,
          y: 0,
          type: 'rollup',
          showCapacity: false,
          color: { r: 50, g: 205, b: 50, a: 1 },
          config: { x: 0, y: 0, type: 'membership' },
        },
      ],
      donation: [
        {
          id: '54a1a3c47d84d983f315a0d8',
          icon: 'none',
          name: 'Donation',
          subTitle: '',
          x: 0,
          y: 0,
          type: 'rollup',
          showCapacity: false,
          color: { r: 50, g: 153, b: 205, a: 1 },
          config: { x: 0, y: 0, type: 'donation' },
        },
      ],
    } as TileMap,

    init() {
      $scope.$on('PosCreatePagesFormsController::Update', ctrl.onPosCreatePagesFormsControllerUpdate);
      $scope.$on('$destroy', ctrl.onDestroy);

      lunchLitelyService.isEnabled('fe_pos_combos').then((enabled) => {
        if (enabled) {
          ctrl.enablePosComboEvents = true;
          ctrl.tiles.comboEvent = [
            {
              id: '54a1a3c47d84d983f315a0d8',
              icon: 'none',
              name: 'Combo Event',
              subTitle: 'Rollup',
              x: 0,
              y: 0,
              type: 'rollup',
              showCapacity: false,
              color: { r: 255, g: 230, b: 119, a: 1 },
              config: { x: 1, y: 1, type: 'comboEvent' },
            },
          ];
        }
      });
    },

    isType(type: string | false) {
      return ctrl.selected.type === type;
    },

    checkPages() {
      return PosConfigService.pages.getModel().length > 1;
    },

    select(type?: string) {
      if (type) {
        ctrl.selectType(type);
      }
      if (ctrl.selected.type) {
        if (ctrl.selected.type !== 'navigation' || (ctrl.selected.type === 'navigation' && ctrl.allowNavigationTiles)) {
          ctrl.model.config.type = ctrl.selected.type;
          ctrl.model.color = (ctrl.tiles as TODO)[ctrl.model.config.type][0].color;
          $scope.$emit('PosCreatePagesFormsTileController::Select', ctrl.model);
        }
      }
    },

    selectType(type: string) {
      ctrl.selected.type = type;
    },

    cancel() {
      ctrl.selected.type = false;
      ctrl.model.config.type = 'tile';
      $scope.$emit('PosCreatePagesFormsTileController::Cancel', ctrl.model);
    },

    onPosCreatePagesFormsControllerUpdate(_e: TODO, data: TODO) {
      if (data.config.type === 'tile') {
        ctrl.model = data;
        ctrl.allowNavigationTiles = ctrl.checkPages();
      }
    },

    onDestroy() {
      ctrl.selected = { type: false };
    },
  };

  $scope.posCreatePagesFormsTile = ctrl;
  ctrl.init();
}

export const PosCreatePagesFormsTileControllerModule = angular
  .module('acme.view.application.pos.create.pages.forms.tile.controllers', [
    'acme.common.service.posConfig',
    'acme.common.directive.posTile',
    LunchLitelyServiceModule,
  ])
  .controller('PosCreatePagesFormsTileController', PosCreatePagesFormsTileController).name;
